var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAir(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2470_696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45851 11.4204C7.60623 11.5312 7.77817 11.6053 7.96015 11.6366C8.14213 11.6679 8.32895 11.6555 8.5052 11.6005C8.68146 11.5454 8.8421 11.4493 8.97391 11.3199C9.10571 11.1906 9.2049 11.0318 9.26329 10.8566C9.32168 10.6815 9.33761 10.4949 9.30976 10.3124C9.28192 10.1298 9.21109 9.95652 9.10312 9.80672C8.99515 9.65692 8.85313 9.53492 8.68876 9.45078C8.52439 9.36663 8.34238 9.32275 8.15773 9.32275H1.16553",
    stroke: "#90A1B9",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1971 4.6613C10.3461 4.46265 10.5434 4.30539 10.7702 4.20444C10.9971 4.10349 11.246 4.0622 11.4933 4.0845C11.7406 4.1068 11.9781 4.19194 12.1832 4.33185C12.3884 4.47175 12.5544 4.66177 12.6654 4.88386C12.7765 5.10595 12.8289 5.35274 12.8177 5.6008C12.8066 5.84885 12.7322 6.08994 12.6016 6.30116C12.4711 6.51238 12.2887 6.68673 12.0719 6.80764C11.855 6.92856 11.6108 6.99203 11.3625 6.99203H1.16553",
    stroke: "#90A1B9",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71046 2.56364C5.85818 2.45285 6.03012 2.37874 6.2121 2.34744C6.39408 2.31613 6.5809 2.32852 6.75715 2.38357C6.93341 2.43863 7.09406 2.53479 7.22586 2.66411C7.35766 2.79344 7.45685 2.95223 7.51524 3.12741C7.57363 3.30259 7.58956 3.48914 7.56172 3.67168C7.53387 3.85422 7.46304 4.02754 7.35507 4.17734C7.2471 4.32713 7.10508 4.44913 6.94071 4.53328C6.77634 4.61742 6.59433 4.6613 6.40968 4.6613H1.16553",
    stroke: "#90A1B9",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2470_696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9844,
    height: 13.9844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.e2e7d77f32801a9580de494900846457.svg";
export { ForwardRef as ReactComponent };